// extracted by mini-css-extract-plugin
module.exports = {"error":"VueLivePreview_error_fOY1Q"};